import AppPopUp from '@/tabs/home/AppPopUp'
import Image from 'next/image'
import React, { useState } from 'react'

const MainBannerSkeleton = (): JSX.Element => {
  const [showPopup, setShowPopup] = useState(false)
  const isMobile = window.innerWidth < 768

  return (
    <>
      <div className="sm:mx-0">
        <button
          className='w-full'
          onClick={() => {
            setShowPopup(true)
          }}
        >
          <Image
            src={isMobile ? '/mweb-banner.png' : '/web-banner.png'}
            alt="Main Banner"
            priority
            width={1400}
            height={300}
            className="w-full h-[220px] sm:h-[300px] object-cover rounded-bl-[32px] rounded-br-[32px] sm:rounded-none"
          />
        </button>
      </div>
      <AppPopUp showPopup={showPopup} setShowPopup={setShowPopup}/>
    </>
  )
}

export default MainBannerSkeleton
